import { css } from 'styled-components';

import { CommonPrismContentCodeStyle } from './prism';
import { CommonTerminalContentCodeStyle } from './terminal';
import { CommonPublicRoomContentCodeStyle } from './public-room';

export const CommonHeaderContentStyles = css`
  // legacy styles
  ${CommonPrismContentCodeStyle}
  ${CommonTerminalContentCodeStyle}
  ${CommonPublicRoomContentCodeStyle}


  .size-50 {
    font-size: 5rem;
  }

  .size-40 {
    font-size: 4rem;
  }

  .size-30 {
    font-size: 3rem;
  }

  .size-28 {
    font-size: 2.8rem;
  }

  .size-24 {
    font-size: 2.4rem;
  }

  .size-20 {
    font-size: 2rem;
  }

  .size-22 {
    font-size: 2.2rem;
  }

  .size-18 {
    font-size: 1.8rem;
  }

  .size-16 {
    font-size: 1.6rem;
  }

  .size-14 {
    font-size: 1.4rem;
  }

  .size-12 {
    font-size: 1.2rem;
  }

  .size-10 {
    font-size: 1rem;
  }

  font-size: 1.6rem;

  & div[style*='font-size:1rem'] {
    font-size: 1.6rem !important;
  }
  & span[style*='font-size:1rem'] {
    font-size: 1.6rem !important;
  }

  a {
    color: ${({ theme }) => theme.colors.info.main};
    outline: 0;
    text-decoration: none;
    background-color: transparent;
    &:hover {
      text-decoration: underline;
    }
  }

  p,
  ul,
  ol {
    margin-bottom: 1.6rem;
    line-height: 2.6rem;
  }

  li {
    line-height: 2.6rem;
  }

  ul {
    list-style: disc;
    box-sizing: border-box;
    padding-left: 4rem;
  }

  ol {
    list-style: decimal;
    box-sizing: border-box;
    padding-left: 4rem;
  }

  hr {
    margin-top: 1.6rem;
    margin-bottom: 1.6rem;
  }

  img {
    max-width: 100%;
    height: auto !important;
  }

  table tr {
    text-align: center;
  }
`;
